import { createAuthClient } from "better-auth/react";
import { runtimeConfig } from "./runtime";

export const authClient = createAuthClient({
  baseURL: runtimeConfig.apiUrl,
  sessionOptions: {
    // The app keeps its authenticated API and realtime connections alive.
    // Refetching the same session every time the tab becomes visible only
    // adds auth traffic; explicit auth actions still refresh this store.
    refetchInterval: 0,
    refetchOnWindowFocus: false,
  },
});
